<template>
  <div class="container wrap pt-5">
    <!--Section: Content-->
    <div class="mb-5 contactUs">
      <!-- Grid row -->
      <div class="row mx-auto">
        <div class="col-12">
          <div class="card z-depth-2">
            <div class="card-body p-0">
              <div class="row contactUs__first">
                <div
                  class="contactUs__second red accent-3 rounded-right pt-4 px-md-5"
                >
                  <div class="d-flex flex-column">
                    <h3 class="text-center">DÉCOUVREZ</h3>
                    <p class="text-center">
                      nos solutions d'automatisation <span>IA</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="page-bg"></div>
              <div class="animation-wrapper">
                <div class="particle particle-1"></div>
                <div class="particle particle-2"></div>
                <div class="particle particle-3"></div>
                <div class="particle particle-4"></div>
              </div>
              <div class="page-wrapper">
                <div class="row contactUs__first">
                  <div class="black rounded-left py-1 px-md-5">
                    <div class="call-action__img">
                      <img
                        src="@/assets/brand/mania-logo.webp"
                        alt="logo"
                        width="500"
                        class="mb-1"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Grid row -->
    </div>
    <!--Section: Content-->
  </div>
</template>

<script>
export default {
  name: "ContactMania",
};
</script>

<style lang="scss" scoped>
.wrap {
  margin-top: 150px;
}
.contactUs {
  position: relative;
  overflow: hidden;
  box-shadow: 3px 5px 27px -5px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 3px 5px 27px -5px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 5px 27px -5px rgba(0, 0, 0, 0.75);
  &:hover {
    & h3 {
      color: $color-text;
      & span {
        color: $color-secondary;
      }
    }
  }
  &__first {
    background: $color-darker;
    display: flex;
    justify-content: center;
    & i {
      font-size: 50px;
      color: $color-primary;
      background: rgba($color: $color-secondary, $alpha: 0.3);
      margin: auto;
      padding: 9px;
      border-radius: 10px;
      @media screen and (min-width: 992px) {
        font-size: 50px;
      }
    }
    & .rounded-left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      @media screen and (min-width: 992px) {
        align-items: center;
      }
      & img {
        background: $color-darker;
        padding: 2px;
        @media screen and (max-width: 992px) {
          margin-top: 1.5rem;
          width: 80vw;
        }
      }
    }
  }
  &__second {
    background: $color-darker;
    display: flex;
    justify-content: center;
    @media screen and (min-width: 992px) {
      width: 70%;
    }
    & h3 {
      font-size: 2em;
      color: $color-text;
      margin: auto;
      &:hover {
        color: $color-text;
        & span {
          color: $color-secondary;
        }
      }
    }
    & p {
      color: $color-text;
    }
    & span {
      color: #0680ff;
      margin-right: 15px;
    }
  }
}
/* Config */
$color-bg: #1e1e1e;
$color-particle: #0680ff;
$spacing: 2560px;
$time-1: 60s;
$time-2: 120s;
$time-3: 180s;
$time-4: 200s;

/* mixins */
@function particles($max) {
  $val: 0px 0px $color-particle;
  @for $i from 1 through $max {
    $val: #{$val}, random($spacing) + px random($spacing) + px $color-particle;
  }
  @return $val;
}

@mixin particles($max) {
  box-shadow: particles($max);
  border-radius: 50%;
}

/* Styles */
html,
body {
  height: 100%;
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 4rem;
  overflow: hidden;
}

.page-bg,
.animation-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.page-bg {
  background: $color-bg;
  background-blend-mode: screen;
  background-size: cover;
  filter: grayscale(100%);
  z-index: -1;
}

.particle,
.particle:after {
  background: transparent;
}

.particle:after {
  position: absolute;
  content: "";
  top: $spacing;
}

.particle-1 {
  animation: animParticle $time-1 linear infinite;
  @include particles(1000);
  height: 2px;
  width: 2px;
}

.particle-1:after {
  @include particles(900);
  height: 2px;
  width: 2px;
}

.particle-2 {
  animation: animParticle $time-2 linear infinite;
  @include particles(800);
  height: 2px;
  width: 2px;
}

.particle-2:after {
  @include particles(500);
  height: 3px;
  width: 3px;
}

.particle-3:after {
  @include particles(1100);
  height: 3px;
  width: 3px;
  border-radius: 50%;
}

.particle-4 {
  animation: animParticle $time-4 linear infinite;
  @include particles(1200);
  height: 1px;
  width: 1px;
}

.particle-4:after {
  @include particles(700);
  height: 1px;
  width: 1px;
}

@keyframes animParticle {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY($spacing * -1);
  }
}

.page-wrapper {
  text-align: center;
  color: #fff;
  z-index: 2;
}

h4 {
  color: #fff;
  font-family: Monoton;
  -webkit-animation: neon1 1.5s ease-in-out infinite alternate;
  -moz-animation: neon1 1.5s ease-in-out infinite alternate;
  animation: neon1 1.5s ease-in-out infinite alternate;
}

h4:hover {
  color: #ff1177;
  -webkit-animation: none;
  -moz-animation: none;
  animation: none;
}

/*glow for webkit*/

@-webkit-keyframes neon1 {
  from {
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #ff1177,
      0 0 70px #ff1177, 0 0 80px #ff1177, 0 0 100px #ff1177, 0 0 150px #ff1177;
  }
  to {
    text-shadow: 0 0 5px #fff, 0 0 10px #fff, 0 0 15px #fff, 0 0 20px #ff1177,
      0 0 35px #ff1177, 0 0 40px #ff1177, 0 0 50px #ff1177, 0 0 75px #ff1177;
  }
}

/*glow for mozilla*/

@-moz-keyframes neon1 {
  from {
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #ff1177,
      0 0 70px #ff1177, 0 0 80px #ff1177, 0 0 100px #ff1177, 0 0 150px #ff1177;
  }
  to {
    text-shadow: 0 0 5px #fff, 0 0 10px #fff, 0 0 15px #fff, 0 0 20px #ff1177,
      0 0 35px #ff1177, 0 0 40px #ff1177, 0 0 50px #ff1177, 0 0 75px #ff1177;
  }
}

/*glow*/

@keyframes neon1 {
  from {
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #ff1177,
      0 0 70px #ff1177, 0 0 80px #ff1177, 0 0 100px #ff1177, 0 0 150px #ff1177;
  }
  to {
    text-shadow: 0 0 5px #fff, 0 0 10px #fff, 0 0 15px #fff, 0 0 20px #ff1177,
      0 0 35px #ff1177, 0 0 40px #ff1177, 0 0 50px #ff1177, 0 0 75px #ff1177;
  }
}
</style>
